import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const Recycled = ({ btn }) => {
  const recycledInfo = (
    <>
      <p>
        The <strong>Recycled Material Platform</strong> is designed to support <strong>environmental protection</strong> and promote a <strong>circular economy</strong>.
      </p>
      <p>
        This platform allows individuals and businesses to collect, sort, and sell <strong>recyclable waste</strong> to industrial sectors for recycling. Users can take initiative by responsibly disposing of garbage in designated zones and turning waste materials into valuable resources.
      </p>
      <p>
        By connecting <strong>waste collectors</strong> with <strong>recycling industries</strong>, the <strong>Recycled Material Platform</strong> helps reduce environmental pollution, encourage sustainable practices, and support recycling-driven industries.
      </p>
           <a href="https://www.youtube.com" target="_blank">
  <strong>Click here to see how to Explore the Market</strong>
</a>
    </>
  );

  return (
    <div>
      <Row>
        <Col lg="12">
          {/* CardNav displays title + full recycled info */}
          <CardNav Header="Recycled Markets" myid={1} myinfo={recycledInfo} />

          {/* BoxData for Recycled Material */}
          <Card className="shadow-main mt-2">
            <BoxData
              Title="Recycled Material"
              Butonn={btn}
              imgg={images.Recycled}
              url="/recycled-integrate"
              link="/recycle-online"
              ms="twentyone-element"
              buy="eighteen"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Recycled;
